<template>
  <div>
    <Workinghours />
    <v-container>
      <div>
        <Ticket2AdminDefaultMessage />
      </div>
    </v-container>
  </div>
</template>

<script>
import Workinghours from '../generali/WorkingHour.vue'
import Ticket2AdminDefaultMessage from '../../billing/Ticket2AdminDefaultMessage.vue'
export default {
  components: {
    Workinghours,
    Ticket2AdminDefaultMessage
  },
  data() {
    return {
      currentView: 'dashboard',
      loading: true
    }
  },
  watch: {},
  created() {},
  async mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/WorkingHour.vue